import React from "react";
import { useLanguage } from "../../Providers/LanguageContext";
import SignUpButton from "./SignUpButton";
import iMg1 from "../../images/Bancos y el Sector Bancario_3-84.png";
import iMg2 from "../../images/Bancos y el Sector Bancario_1-82.png";
import iMg3 from "../../images/Bancos y el Sector Bancario_2-83.png";
import iMg4 from "../../images/Bancos y el Sector Bancario_4-85.png";
import iMg5 from "../../images/Bancos y el Sector Bancario_5-86.png";
import iMg6 from "../../images/Bancos y el Sector Bancario_6-87.png";
import iMg7 from "../../images/Bancos y el Sector Bancario-88.png";
import bodyimage from "../../images/fondo.png";
import tick from "../../images/tick.png";
import { useNavigate } from "react-router-dom";
import { useUserData } from "../../Providers/UserWrapper";
import circle from '../../images/Ellipse 17.png'
import laptop from '../../images/image (17).png'
import laptop2 from '../../images/image (19).png'
import dollar from '../../images/image 9.png'
import trading from '../../images/image (18).png'
import file from '../../images/image 11.png'
import circle2 from '../../images/Ellipse 18.png'
import signup from '../../images/image 13.png'
import UserBanner from "./UserBanner";
import guysitting from '../../images/image 15.png'
import magnify from '../../images/image (20).png'
import shield from '../../images/image (21).png'
import parliament from '../../images/image (22).png'
const BankIndustry = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const { logout, isLogin } = useUserData();
  const bank = true;
  return (
    <>
      <section
        id="agriculture_sec"
        className="banking d-none"
        style={{ backgroundImage: `url('${bodyimage}')`, position: "relative" }}
      >
        <div className="container">
          <div className="agriculture_head" style={{ marginBottom: "0" }}>
            <h3 style={{ color: "#0e2537" }}>
              {language.fisi_key_benifits}
            </h3>
          </div>
          <div className="row mb-5">
            <div className="col-md-6 col-12">
              <div className="agriculture_headtext">
                <h5>
                  {language.bank_and_industry}
                </h5>
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.enhance_risk_management}
                    </h4>
                    <p>
                      {language.fisi_compre_data}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg2} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="col-md-12 col-12 rightsideGap">
            <div className="agriculture_headtext">
              <div className="tickpara">
                <div className="tick">
                  <img src={tick}></img>
                </div>
                <div>
                  <h4 style={{ color: "#333333" }}>{language.improved_effi}</h4>
                  <p>
                    {language.fisi_plat_stand}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-7 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>{language.increased_trans}</h4>
                    <p>
                      {language.fisi_tran_finan}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg3} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg1} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.streamline_ac}
                    </h4>
                    <p>
                      {language.fisi_digi_chear}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8 col-12">
            <div className="agriculture_headtext">
              <div className="tickpara">
                <div className="tick">
                  <img src={tick}></img>
                </div>
                <div>
                  <h4 style={{ color: "#333333" }}>
                    {language.access_compre_finance}
                  </h4>
                  <p>
                    {language.encorage_busi_data}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg4} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.improve_port_manage}
                    </h4>
                    <p>
                      {language.fisi_busi_invest}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.inc_cust_sat}
                    </h4>
                    <p>
                      {language.prov_busi_comp}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg5} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="col-md-12 col-12 rightsideGap">
            <div className="agriculture_headtext">
              <div className="tickpara">
                <div className="tick">
                  <img src={tick}></img>
                </div>
                <div>
                  <h4 style={{ color: "#333333" }}>
                    {language.red_admin_cost}
                  </h4>
                  <p>
                    {language.fisi_plat_auto}
                  </p>
                </div>
              </div>
            </div>
          </div>


          <div className="row mb-5">
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.better_deci_making}
                    </h4>
                    <p>
                      {language.fisi_plat_prov_bank}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg6} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg7} className="img-fluid" alt="" />
                <div className='registrarAnddescargar' style={{ transform: "translate(-50% , -50%)", top: "64%", }}>

                  <button
                    onClick={() => navigate('/price')}
                    className='registrar_Btn'
                    style={{ background: "linear-gradient(to right, rgb(24, 70, 93) 1%, rgb(15, 40, 59) 100%, rgb(41, 137, 216) 100%); border: 0px; margin-bottom: 20px", border: "0" }}
                  >
                    {language.homeBannerBtn1}
                  </button>

                  <a href='https://fisibilitylite.com/app_api/share_url.html' target="_blank">
                    <button className='descargar_Btn' style={{ borderColor: "#102c3f", color: "#102c3f", backgroundColor: "#fff" }}>{language.homeBannerBtn2}</button>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.imp_rge_comp}
                    </h4>
                    <p>
                      {language.fisi_plat_design}
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <div className="general_user_wrapper">
        <UserBanner bank={bank} />
        <div className="general_user_management_all_content_wrapper">

          <div className="general_financial_management_Wrapper">

            <div className="container-fluid financial_management_content_wrapper">
              <div className="financial_management_left">
                <h1> {language.improved_effi}</h1>
                <p>   {language.fisi_plat_stand}</p>
              </div>
              <div className="financial_management_right">
                <img src={laptop} />
              </div>
            </div>
          </div>



          <div className="general_financial_management_Wrapper" >

            <div className="container-fluid financial_management_content_wrapper">
              <div className="circle_img_1">
                <img className="cirle_svg_1" src={circle} />
              </div>
              <div className="financial_management_right">
                {/* <img src={dollar} /> */}
              </div>


              <div className="financial_management_left">
                <h1>{language.increased_trans}</h1>
                <p>    {language.fisi_tran_finan}</p>
              </div>
            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_right" style={{
                zIndex: 9
              }}>
                <img src={trading} />
              </div>


              <div className="financial_management_left">
                <h1>   {language.streamline_ac}</h1>
                <p>          {language.fisi_digi_chear}</p>
              </div>






            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            {/* <img className="cirle_svg_3" src={circle2} style={{
          position:'absolute',
          bottom:'-100px',
          left:'50px',
          width:'300px',
          height:'300px'
        }}/> */}
            <div className="container-fluid financial_management_content_wrapper">




              <div className="financial_management_left">
                <h1> {language.access_compre_finance}</h1>
                <p>    {language.encorage_busi_data} </p>
              </div>


              <div className="financial_management_right">

              </div>





            </div>
          </div>


          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            {/* <img className="cirle_svg_3" src={circle2} style={{
              position: 'absolute',
              bottom: '-100px',
              left: '50px',
              width: '300px',
              height: '300px'
            }} /> */}
            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_left">
                <h1>      {language.improve_port_manage}</h1>
                <p>       {language.fisi_busi_invest}</p>
              </div>

              <div className="financial_management_right">
                <img src={laptop2} />
              </div>







            </div>
          </div>

          <div className="general_financial_management_Wrapper" style={{
            padding: '0px 0px'
          }}>
            <img className="cirle_svg_3" src={circle2} style={{
              position: 'absolute',
              top: '150px',
              left: '0px',
              width: '300px',
              height: '300px'
            }} />
            <div className="container-fluid financial_management_content_wrapper">

              {/* <div className="financial_management_left">
                <h1>  {language.investment_tracking}</h1>
                <p>{language.fisi_invest_trackibg}</p>
              </div> */}
              <div className="financial_management_right">
                <img src={magnify} />
              </div>
              <div className="financial_management_left">
                <h1>  {language.inc_cust_sat}</h1>
                <p>         {language.prov_busi_comp}</p>
              </div>







            </div>
          </div>


          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_left">
                <h1>    {language.red_admin_cost} </h1>
                <p>        {language.fisi_plat_auto}</p>
              </div>
              <div className="financial_management_right"></div>








            </div>
          </div>



          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">

              <div className="financial_management_left">
                <h1>  {language.better_deci_making}</h1>
                <p>              {language.fisi_plat_prov_bank}</p>
              </div>
              <div className="financial_management_right">
                <img src={shield} />
              </div>








            </div>
          </div>






          <div className="general_financial_management_Wrapper" style={{
            padding: '30px 0px'
          }}>

            <div className="container-fluid financial_management_content_wrapper">
              <div className="financial_management_right">
                <img src={parliament} />
              </div>
              <div className="financial_management_left">
                <h1>     {language.imp_rge_comp}</h1>
                <p>      {language.fisi_plat_design}</p>
              </div>











            </div>
          </div>

        </div>

      </div>

    </>
  );
};

export default BankIndustry;
